// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/search-cross.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/search-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-icon-react {
    cursor: pointer;
    line-height: 1;
    margin-left: 5px;
    margin-right: 5px;
    padding-right: 10px;
    padding-left: 10px;
    position: relative;
    margin-top: 15px;
}

.search-icon-react .search-close-react:after {
  width: 20px;
  height: 20px;
  position: static;
  display: inline-block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: 18px;
  filter: brightness(0) invert(1);
}

.search-container-react {
    position: relative;
    display: block;
    margin-bottom: 20px;
}

.search-icon-react svg {
    fill: #fff;
    margin-left: 30px;
}

.search-icon-react:hover svg path{
   fill: #eda105
}

.search-icon-react:hover:before {
    position: absolute;
    font-family: RobotoRegular, sans-serif;
    font-style: normal;
    z-index: 1;
    color: #ecf2fc;
    background-color: #292929;
    padding: 5px 10px;
    font-size: 0.875rem;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 2px;
    border: 1px solid #6a6a6a;
    width: max-content;
}

.search-icon-react:hover:after {
    border-left: solid transparent 4px;
    border-right: solid transparent 4px;
    border-bottom: solid #6a6a6a 7px;
    top: 23px;
    height: 0;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    width: 0;
}

.search-close-react {
  transform: scale(1.5);
  width: 20px;
  height: 20px;
  position: static;
  display: inline-block;
  /* background: url(../../images/search-cross.png) no-repeat center center; */
  background-size: 18px;
  filter: brightness(0) invert(1);
}

.search-close-react:hover {
     
    filter: none;
}

.search-form-container-react:after {
    /* background: url("./../../images/ic-search.svg") no-repeat; */
    background-size: 15px;
    height: 15px;
    position: absolute;
    top: 12px;
    left: 10px;
    width: 15px;
    z-index: 99;
}

.search-box-react {
    top: -9px;
    z-index: 2;
    right: 0px;
    position: absolute;
    width: 44rem;
    padding: 0;
    display: block !important;
}

.search-filter-react {
    padding: 0;
    margin: 0;
    height: 60px;
    display: flex;
}

.header-search-box-react {
    top: -9px;
    z-index: 2;
    right: 50px;
    position: absolute;
    width: 700px;
    padding: 0;
    display: block !important;
}

.header-search-filter-react {
    padding: 0;
    margin: 0;
    height: 45px;
    display: flex;
}

.homepage-approvals-search-react {
    margin: 0;
    display: flex;
    width: 100%;
}

.search-form-container-react {
    width: 100%;
}

.search-list-container-react {
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 98;
  background: #fff;
  overflow: auto;
  -webkit-overflow-scrolling: touch !important;
  margin-top: 3px !important;
  box-shadow: 2px 10px 19px 0 rgba(95, 94, 95, 0.56);
  border-radius: 5px;
  min-height: 10vh;
  max-height: 42vh;
  min-width: 502px;
  transition: none;
  max-width: calc(100% - 30px);
}

.search-list-container-react ul {
    z-index: 99999999;
    background-color: #6AC977;
}


.search-list-container-react li {
    border: none;
    display: block;
    padding: 12px 20px !important;
    cursor: pointer;
    font-size: 0.875rem;
    line-height: 1.4;
    color: black;
    -webkit-transition: 0.3s all ease;
    transition: 0.3s all ease;
    margin: 0 !important;
    text-align: left;
    width: 533px;
    font-family: RobotoRegular, sans-serif;
}

.search-list-container-react li:hover {
    color: #F2943B !important;
    background-color: #FEF7EF !important;
}

.search-list-container-react li.no-data-react {
    font-family: RobotoBold, sans-serif;
}

.search-list-container-react li:last-child {
    border-bottom: 0;
}

.approvals-search-box-react {
    border: none;
    width: 100%;
    height: 100%;
    padding-left: 38px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: 10px center;
    font-family: KhandRegular, sans-serif;
    line-height: 1;
    font-size: 1.063rem;
}

/******Green button********/
/* .button-green-react {
    align-items: center;
    border-top-right-radius: 2.5px;
    border-bottom-right-radius: 2.5px;
    background-color: #6AC977;
    border: 1px solid #6AC977;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.09);
    color: #fff;
    cursor: pointer;
    display: inline-flex;
    font-size: 1rem;
    justify-content: center;
    min-width: 131px;
    padding-right: 15px;
    padding-left: 15px;
    font-family: 'Khand-bold', sans-serif;
    text-shadow: 0px 1px 0 #3d9249;
    font-weight: bold;
    text-transform: uppercase;
    text-decoration: none;
    -webkit-print-color-adjust: exact;
} */

.css-13cymwt-control, .css-t3ipsp-control {
    height: 100% !important;
    width: max-content;
    border-radius: 0 !important;
}

a:focus-visible,input:focus-visible ,select:focus-visible,button:focus-visible,textarea:focus-visible{
  border: 0px !important;
}   

.button-green-react {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 31px 30px;
  background: #16a34a;
  color: #ffffff;
  text-decoration: none;
  border-radius: 0px;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  transition: background 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
}

.button-green-react::after {
  content: "→";
  transition: transform 0.25s ease;
}

.button-green-react:hover {
  background: #15803d;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(22, 163, 74, 0.4);
}

.button-green-react:hover::after {
  transform: translateX(5px);
}`, "",{"version":3,"sources":["webpack://./js/src/commonSearch.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,2EAAsE;EACtE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;GACG;AACH;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,gCAAgC;IAChC,SAAS;IACT,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,4EAA4E;EAC5E,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,+DAA+D;IAC/D,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;AACf;;AAEA;IACI,SAAS;IACT,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,4CAA4C;EAC5C,0BAA0B;EAC1B,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;;AAGA;IACI,YAAY;IACZ,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,iCAAiC;IACjC,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yDAA4D;IAC5D,4BAA4B;IAC5B,gCAAgC;IAChC,qCAAqC;IACrC,cAAc;IACd,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;IACI,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,6EAA6E;EAC7E,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".search-icon-react {\r\n    cursor: pointer;\r\n    line-height: 1;\r\n    margin-left: 5px;\r\n    margin-right: 5px;\r\n    padding-right: 10px;\r\n    padding-left: 10px;\r\n    position: relative;\r\n    margin-top: 15px;\r\n}\r\n\r\n.search-icon-react .search-close-react:after {\r\n  width: 20px;\r\n  height: 20px;\r\n  position: static;\r\n  display: inline-block;\r\n  background: url(../../images/search-cross.png) no-repeat center center;\r\n  background-size: 18px;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n.search-container-react {\r\n    position: relative;\r\n    display: block;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.search-icon-react svg {\r\n    fill: #fff;\r\n    margin-left: 30px;\r\n}\r\n\r\n.search-icon-react:hover svg path{\r\n   fill: #eda105\r\n}\r\n\r\n.search-icon-react:hover:before {\r\n    position: absolute;\r\n    font-family: RobotoRegular, sans-serif;\r\n    font-style: normal;\r\n    z-index: 1;\r\n    color: #ecf2fc;\r\n    background-color: #292929;\r\n    padding: 5px 10px;\r\n    font-size: 0.875rem;\r\n    top: 30px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    border-radius: 2px;\r\n    border: 1px solid #6a6a6a;\r\n    width: max-content;\r\n}\r\n\r\n.search-icon-react:hover:after {\r\n    border-left: solid transparent 4px;\r\n    border-right: solid transparent 4px;\r\n    border-bottom: solid #6a6a6a 7px;\r\n    top: 23px;\r\n    height: 0;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    position: absolute;\r\n    width: 0;\r\n}\r\n\r\n.search-close-react {\r\n  transform: scale(1.5);\r\n  width: 20px;\r\n  height: 20px;\r\n  position: static;\r\n  display: inline-block;\r\n  /* background: url(../../images/search-cross.png) no-repeat center center; */\r\n  background-size: 18px;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n.search-close-react:hover {\r\n     \r\n    filter: none;\r\n}\r\n\r\n.search-form-container-react:after {\r\n    /* background: url(\"./../../images/ic-search.svg\") no-repeat; */\r\n    background-size: 15px;\r\n    height: 15px;\r\n    position: absolute;\r\n    top: 12px;\r\n    left: 10px;\r\n    width: 15px;\r\n    z-index: 99;\r\n}\r\n\r\n.search-box-react {\r\n    top: -9px;\r\n    z-index: 2;\r\n    right: 0px;\r\n    position: absolute;\r\n    width: 44rem;\r\n    padding: 0;\r\n    display: block !important;\r\n}\r\n\r\n.search-filter-react {\r\n    padding: 0;\r\n    margin: 0;\r\n    height: 60px;\r\n    display: flex;\r\n}\r\n\r\n.header-search-box-react {\r\n    top: -9px;\r\n    z-index: 2;\r\n    right: 50px;\r\n    position: absolute;\r\n    width: 700px;\r\n    padding: 0;\r\n    display: block !important;\r\n}\r\n\r\n.header-search-filter-react {\r\n    padding: 0;\r\n    margin: 0;\r\n    height: 45px;\r\n    display: flex;\r\n}\r\n\r\n.homepage-approvals-search-react {\r\n    margin: 0;\r\n    display: flex;\r\n    width: 100%;\r\n}\r\n\r\n.search-form-container-react {\r\n    width: 100%;\r\n}\r\n\r\n.search-list-container-react {\r\n  margin: 0;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 98;\r\n  background: #fff;\r\n  overflow: auto;\r\n  -webkit-overflow-scrolling: touch !important;\r\n  margin-top: 3px !important;\r\n  box-shadow: 2px 10px 19px 0 rgba(95, 94, 95, 0.56);\r\n  border-radius: 5px;\r\n  min-height: 10vh;\r\n  max-height: 42vh;\r\n  min-width: 502px;\r\n  transition: none;\r\n  max-width: calc(100% - 30px);\r\n}\r\n\r\n.search-list-container-react ul {\r\n    z-index: 99999999;\r\n    background-color: #6AC977;\r\n}\r\n\r\n\r\n.search-list-container-react li {\r\n    border: none;\r\n    display: block;\r\n    padding: 12px 20px !important;\r\n    cursor: pointer;\r\n    font-size: 0.875rem;\r\n    line-height: 1.4;\r\n    color: black;\r\n    -webkit-transition: 0.3s all ease;\r\n    transition: 0.3s all ease;\r\n    margin: 0 !important;\r\n    text-align: left;\r\n    width: 533px;\r\n    font-family: RobotoRegular, sans-serif;\r\n}\r\n\r\n.search-list-container-react li:hover {\r\n    color: #F2943B !important;\r\n    background-color: #FEF7EF !important;\r\n}\r\n\r\n.search-list-container-react li.no-data-react {\r\n    font-family: RobotoBold, sans-serif;\r\n}\r\n\r\n.search-list-container-react li:last-child {\r\n    border-bottom: 0;\r\n}\r\n\r\n.approvals-search-box-react {\r\n    border: none;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding-left: 38px;\r\n    background-image: url(\"../../assets/images/search-icon.svg\");\r\n    background-repeat: no-repeat;\r\n    background-position: 10px center;\r\n    font-family: KhandRegular, sans-serif;\r\n    line-height: 1;\r\n    font-size: 1.063rem;\r\n}\r\n\r\n/******Green button********/\r\n/* .button-green-react {\r\n    align-items: center;\r\n    border-top-right-radius: 2.5px;\r\n    border-bottom-right-radius: 2.5px;\r\n    background-color: #6AC977;\r\n    border: 1px solid #6AC977;\r\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.09);\r\n    color: #fff;\r\n    cursor: pointer;\r\n    display: inline-flex;\r\n    font-size: 1rem;\r\n    justify-content: center;\r\n    min-width: 131px;\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n    font-family: 'Khand-bold', sans-serif;\r\n    text-shadow: 0px 1px 0 #3d9249;\r\n    font-weight: bold;\r\n    text-transform: uppercase;\r\n    text-decoration: none;\r\n    -webkit-print-color-adjust: exact;\r\n} */\r\n\r\n.css-13cymwt-control, .css-t3ipsp-control {\r\n    height: 100% !important;\r\n    width: max-content;\r\n    border-radius: 0 !important;\r\n}\r\n\r\na:focus-visible,input:focus-visible ,select:focus-visible,button:focus-visible,textarea:focus-visible{\r\n  border: 0px !important;\r\n}   \r\n\r\n.button-green-react {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 31px 30px;\r\n  background: #16a34a;\r\n  color: #ffffff;\r\n  text-decoration: none;\r\n  border-radius: 0px;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  letter-spacing: 0.3px;\r\n  text-transform: uppercase;\r\n  transition: background 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;\r\n  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);\r\n}\r\n\r\n.button-green-react::after {\r\n  content: \"→\";\r\n  transition: transform 0.25s ease;\r\n}\r\n\r\n.button-green-react:hover {\r\n  background: #15803d;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 20px rgba(22, 163, 74, 0.4);\r\n}\r\n\r\n.button-green-react:hover::after {\r\n  transform: translateX(5px);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
